module.exports = __webpack_public_path__ + "static/media/ucsd.de94562b.png";